module.exports = __webpack_public_path__ + "static/media/post-event-mid.defe20c5.png";